
import { useContext, useEffect, useState } from "react";

import Container from "../../components/Container";
import ContentTemplate from "../../components/Layout/contentTemplate";
import { Context } from "../../utils/store";
import Layout from "../../components/Layout";
import fetchData from "../../utils/fetch";
import fetchRequestLibrary from "../../utils/fetchRequestLibrary";
import CustomHead from '../../components/CustomHead'
const SIZE_OF_BLOCKS = 9; // Number of articles per blocks

function Rubrique({
    articles,
    idRubrique,
    mainParams,
    parentName,
    thematiques,
    breakingNews,
    cities,
    ephemeralChannels,
    liveData,
    medias,
    auboisVousInforment,
    app
}) {

    useEffect(() => {
        if (parentName !== topicName) {
            setListArticles(articles.items);
            setTopicName(parentName);
        }
    }, [parentName]);

    useEffect(() => {
        if (app) {
            console.log('Logging content...');

            app.analytics().logEvent('select_content', {
                item_id: idRubrique,
                item_name: parentName,
                item_variant: 'rubrique'
            });
            
        }
    }, [app, parentName]);
    
    const [blockNb, setBlockNb] = useState(1);
    const [topicName, setTopicName] = useState(parentName)
    const [listArticles, setListArticles] = useState(articles.items);
    const context = useContext(Context);
    async function seeMoreFunction() {
        let param = mainParams;
        param.push({ name: "offset", value: blockNb * SIZE_OF_BLOCKS });
        let articles_fetched = await fetchData(
            process.env.SOURCE_API + "rest/2.0/medias/get.php",
            "POST",
            param,
            true
        );
        setListArticles([...listArticles, ...articles_fetched.items]);
        setBlockNb(blockNb + 1);
    }
    return (
        <Context.Provider
            value={{
                ...context,
                medias: medias,
                thematiques: thematiques,
                cities: cities,
                breakingNews: breakingNews,
                liveData: liveData,
                auboisVousInforment: auboisVousInforment,
                ephemeralChannels: ephemeralChannels,
                rubriqueData: { idRubrique: idRubrique, parentName: parentName },
            }}
        >
            <Layout>
                <Container>
                    <CustomHead title={parentName} article={listArticles[0]} description={`Retrouvez toute l'actu ${parentName} de Troyes et de l'Aube`}/>
                    <ContentTemplate data={listArticles} type={"rubrique"} onClickFunction={seeMoreFunction}/>
                </Container>
            </Layout>
        </Context.Provider>
    );
}
export async function getServerSideProps(context) {
    let { uri } = context.params;

    const {
        thematiques,
        breakingNews,
        cities,
        ephemeralChannels,
        liveData,
        medias,
        auboisVousInforment
    } = await fetchRequestLibrary();

    const thematique = await fetchData(
        process.env.SOURCE_API + "rest/2.0/categories/getThematiqueByAlias.php",
        "POST",
        [{ name: "uri", value: `thematiques/${uri}/` }]
    );
    let params = [
        { name: "limit", value: SIZE_OF_BLOCKS },
    ];
    for(let parent of thematique?.items[0]?.list_id){
        params.push(
            {
                name:'parent[]',
                value : parent,
            }
        )
    }
    const articles = await fetchData(
        process.env.SOURCE_API + "rest/2.0/medias/get.php",
        "POST",
        params
    );

    let parentName = "";
    if (articles.items.length) parentName = articles.items[0].parentName;

    return {
        props: {
            articles,
            idRubrique: thematique?.items[0]?.id_rubrique,
            mainParams : params, 
            parentName,
            thematiques,
            breakingNews,
            cities,
            ephemeralChannels,
            liveData,
            medias,
            auboisVousInforment
        },
    };
}

export default Rubrique;
